<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-70 md-medium-size-100 px-0">
      <!-- GREETING -->
      <div class="md-layout-item">
        <greeting :info="info"></greeting>
      </div>
      <!-- GREETING -->

      <div class="md-layout">
        <!-- CLASSES IN PROGRESS -->
        <div class="md-layout-item md-size-100">
          <card-dashboard
            v-if="!classesInProgressData"
            :title="$t('dashboard.class_in_progress', { length: 0 })"
          >
            <div class="flex justify-center">
              <no-data-found></no-data-found>
            </div>
          </card-dashboard>
          <classes-in-progress-teacher
            v-else
            :classesInProgress="classesInProgressData"
          ></classes-in-progress-teacher>
        </div>
        <!-- CLASSES IN PROGRESS -->

        <!-- CHART CLASSES -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <div ref="chartClasses">
            <card-dashboard :title="$t('dashboard.my_classes')">
              <div class="flex justify-center" v-if="!chartData">
                <no-data-found></no-data-found>
              </div>
              <div class="md-layout justify-center h-[213px]" v-else>
                <div
                  class="md-layout-item md-large-size-80 md-size-70 max-h-full"
                >
                  <classes-chart-teacher
                    :classesData="chartData"
                    class="max-h-full"
                  ></classes-chart-teacher>
                </div>
              </div>
            </card-dashboard>
          </div>
        </div>
        <!-- CHART CLASSES -->

        <!-- STUDENTS IN CLASSES -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <card-dashboard
            :title="$t('dashboard.students_in_classes')"
            :style="{ height: chartData ? heightChart : 'unset' }"
          >
            <div class="flex justify-center" v-if="!totalStudents">
              <no-data-found></no-data-found>
            </div>
            <student-overview :data="totalStudents" v-else></student-overview>
          </card-dashboard>
        </div>
        <!-- STUDENTS IN CLASSES -->
      </div>

      <!-- ASSIGNED STUDENTS -->
      <div class="md-layout-item">
        <card-dashboard
          v-if="!studentList"
          :title="$t('dashboard.assigned_students', { length: 0 })"
        >
          <div class="flex justify-center">
            <no-data-found></no-data-found>
          </div>
        </card-dashboard>
        <assigned-student
          v-else
          :dataAssignStudent="studentList"
        ></assigned-student>
      </div>
      <!-- ASSIGNED STUDENTS -->
    </div>

    <div class="md-layout-item md-size-30 md-medium-size-100">
      <external-link></external-link>
      <!-- UPCOMING EVENTS -->
      <upcoming-events
        :path="path.upcomingEvents"
        :showTakeAttendance="true"
      ></upcoming-events>
      <!-- UPCOMING EVENTS -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpcomingEvents from "../../Components/UpcomingEvents";
import CardDashboard from "../../Components/CardDashboard";
import { service_paths } from "@/constants/Services";
import StudentOverview from "./StudentOverview";
import AssignedStudent from "./AssignedStudent";
import ClassesInProgressTeacher from "./ClassesInProgress";
import ClassesChartTeacher from "./ClassesChart";
import { getId, initLoader } from "@/helpers/utils";
import Greeting from "../../Components/Gretting";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import ExternalLink from "../../Components/ExternalLink";

export default {
  name: "dashboard-teacher",
  components: {
    ExternalLink,
    NoDataFound,
    Greeting,
    ClassesChartTeacher,
    ClassesInProgressTeacher,
    AssignedStudent,
    StudentOverview,
    CardDashboard,
    UpcomingEvents
  },
  data() {
    return {
      path: {
        upcomingEvents: `${service_paths.calendars}/current-user/dashboard`,
        classes: `${service_paths.dashboard}/classes`,
        studentOverview: `${service_paths.dashboard}/classes/students-overview`,
        classesProgress: `${service_paths.classes}/in-process`,
        assignedStudent: service_paths.users
      },
      chartData: null,
      tooltipsCallbackCfg: {
        title: {
          prefix: this.$t("common.on_going")
        },
        label: true
      },
      totalStudents: {},
      classesInProgressData: null,
      studentList: null,
      heightChart: ""
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  watch: {
    chartData() {
      this.getHeight();
    }
  },
  created() {
    const loader = initLoader();

    Promise.all([
      this.fetchDataClasses(),
      this.fetchDataStudentOverview(),
      this.fetchClassesInProgress(),
      this.fetchDataStudentList()
    ]).finally(() => {
      loader.hide();
    });
  },
  methods: {
    fetchDataClasses() {
      return this.$axios
        .get(
          `${this.path.classes}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.chartData = data.data.length ? data : false;
          }
        });
    },

    fetchDataStudentOverview() {
      return this.$axios
        .get(
          `${this.path.studentOverview}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.totalStudents = data.total ? data : false;
        });
    },

    fetchClassesInProgress() {
      const uuid = this.info.uuid;
      return this.$axios
        .get(
          `${this.path.classesProgress}/${uuid}/user`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.classesInProgressData = data.total ? data : false;
        });
    },

    fetchDataStudentList() {
      return this.$axios
        .get(
          `${this.path.assignedStudent}/${getId(this.info)}/assigned-students`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.studentList = data.data.length ? data.data : false;
        });
    },

    getHeight() {
      this.$nextTick(() => {
        this.heightChart = this.$refs.chartClasses.clientHeight + "px";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-classes {
  margin-top: -50px;

  @media screen and (max-width: 1919px) {
    margin-top: -97px;
  }
}
</style>
